import { MbbSubscriptionOffering, MbbRouter } from '../../modules/mbb/models/mbb-offerings-response.model';

export class ApiGetProductOfferingsMbbAction {
  static readonly type = '[Api] Get MBB Product Offerings';
}

export class ApiGetProductOfferingsMbbSuccessAction {
  static readonly type = '[Api] Get MBB Product Offerings Success';
  constructor(public response: MbbSubscriptionOffering[]) {}
}

export class ApiGetProductOfferingsMbbErrorAction {
  static readonly type = '[Api] Get MBB Product Offerings error';
}

export class ApiGetAllMbbRoutersAction {
  static readonly type = '[Api] Get all MBB routers';
}

export class ApiGetAllMbbRoutersSuccessAction {
  static readonly type = '[Api] Get all MBB routers success';
  constructor(public response: MbbRouter[]) {}
}

export class ApiGetAllMbbRoutersErrorAction {
  static readonly type = '[Api] Get all MBB routers error';
}

export class MBBOfferingResetAction {
  static readonly type = '[Offering MBB] Reset mbb offering state';
}
